var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.itemsLength),function(_,lIndex){return _c('div',{key:'sidebar-item' + lIndex,staticClass:"mb-4"},[_c('b-skeleton',{attrs:{"height":"1.5rem","width":"6rem"}}),_c('b-skeleton',{attrs:{"height":"2rem"}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }